module.exports = __webpack_public_path__ + "static/media/lp6.0d66066f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lp6.webp
// module id = 1717
// module chunks = 31